export default function (axios, api) {
  return {
    state: {
      questionnaireCatId: null,
      questionnaire: {},
      questionnaires: {},
      questionnaireResults: {}
    },

    getters: {
      questionnaire: state => state.questionnaire,
      questionnaires: state => state.questionnaires,
      questionnaireCatId: state => state.questionnaireCatId,
      questionnaireResults: state => state.questionnaireResults
    },

    actions: {
      getQuestionnaires ({ commit }) {
        return new Promise((resolve, reject) => {
          api.fetchPublicQuestionnaires().then(questionnaires => {
            commit('setQuestionnaires', questionnaires)
            resolve()
          }).catch(err => reject(err))
        })
      },

      getQuestionnaire ({ commit, getters }, id) {
        return new Promise((resolve, reject) => {
          api.fetchQuestionnaire(id).then(questionnaire => {
            // set chosen counted for multiple choice questions
            questionnaire.questions.forEach(q => {
              q.numChosen = 0

              q.choices.forEach(c => {
                c.selected = false
                c.disabled = false
              })
            })

            commit('setQuestionnaire', questionnaire)
            if (getters.route.name === 'questionnaire') {
              commit('setTitle', questionnaire.post_title)
            }
            resolve()
          }).catch(err => reject(err))
        })
      },

      voteOnQuestionnaire ({ commit }, { id, answers }) {
        return api.voteOnQuestionnaire(id, answers.filter(a => a.choices.length > 0))
          .then(response => {
            commit('setQuestionnaire', response)
          })
      },

      getResults ({ commit }, id) {
        return api.getResults(id).then(results => {
          commit('setQuestionnaireResults', results)
        })
      }
    },

    mutations: {
      setQuestionnaireCatId (state, catId) {
        state.questionnaireCatId = catId
      },

      setQuestionnaires (state, questionnaires) {
        state.questionnaires = questionnaires
      },

      setQuestionnaire (state, questionnaire) {
        state.questionnaire = questionnaire
      },

      setQuestionnaireResults (state, results) {
        state.questionnaireResults = results
      }

    }
  }
}
